import { createAction, props } from '@ngrx/store';

// View toggle
export const ViewCustomer = createAction('[All Customers: Summary]: View Customer', props<{ customer: any }>());
export const ViewCustomerById = createAction(
  '[All Customers: Summary]: View Customer By Id',
  props<{ personId: number }>(),
);
export const ViewCustomerSearchPage = createAction('[All Customers: Summary]: View Customer Search Page');
export const EditCustomer = createAction('[All Customers: Summary]: Edit Customer', props<{ customer: any }>());

// Load customer data
export const LoadCustomerSummaryData = createAction('[All Customers: Summary]: Load Customer Summary Data');
export const LoadCustomerDetailsData = createAction('[All Customers: Details]: Load Customer Details Data');

// Get customer details
export const GetCustomerDetailsSuccess = createAction(
  '[All Customers: Summary]: Get Customer Details Success',
  props<{ res: any }>(),
);
export const GetCustomerDetailsFailed = createAction(
  '[All Customers: Summary]: Get Customer Details Failed',
  props<{ error: any }>(),
);

// Get customer membership
export const GetCustomerMembershipSuccess = createAction(
  '[All Customers: Summary]: Get Customer Membership Success',
  props<{ res: any }>(),
);
export const GetCustomerMembershipFailed = createAction(
  '[All Customers: Summary]: Get Customer Membership Failed',
  props<{ error: any }>(),
);

// Get person sources
export const GetPersonSourcesSuccess = createAction(
  '[All Customers: Summary]: Get Person Sources Success',
  props<{ res: any }>(),
);
export const GetPersonSourcesFailed = createAction(
  '[All Customers: Summary]: Get Person Sources Failed',
  props<{ error: any }>(),
);

// Campaigns panel
export const OpenCustomerCampaignsPanel = createAction('[All Customers: Summary]: Open Campaigns Panel');
export const GetCustomerCampaignsTableLoading = createAction('[All Customers: Summary]: Get Campaigns Table Loading');
export const GetCustomerCampaignsTableSuccess = createAction(
  '[All Customers: Summary]: Get Campaigns Table Success',
  props<{ res: any }>(),
);
export const GetCustomerCampaignsTableFailed = createAction(
  '[All Customers: Summary]: Get Campaigns Table Failed',
  props<{ error: any }>(),
);
export const GetCustomerCampaignsCountSuccess = createAction(
  '[All Customers: Summary]: Get Campaigns Count Success',
  props<{ res: number }>(),
);
export const GetCustomerCampaignsCountFailed = createAction(
  '[All Customers: Summary]: Get Campaigns Count Failed',
  props<{ error: any }>(),
);

// Tickets panel
export const OpenCustomerTicketsPanel = createAction('[All Customers: Summary]: Open Tickets Panel');
export const GetCustomerTicketsTableLoading = createAction('[All Customers: Summary]: Get Tickets Table Loading');
export const GetCustomerTicketsTableSuccess = createAction(
  '[All Customers: Summary]: Get Tickets Table Success',
  props<{ res: any }>(),
);
export const GetCustomerTicketsTableFailed = createAction(
  '[All Customers: Summary]: Get Tickets Table Failed',
  props<{ error: any }>(),
);
export const GetCustomerTicketsCountSuccess = createAction(
  '[All Customers: Summary]: Get Tickets Count Success',
  props<{ res: number }>(),
);
export const GetCustomerTicketsCountFailed = createAction(
  '[All Customers: Summary]: Get Tickets Count Failed',
  props<{ error: any }>(),
);

// Transactions panel
export const OpenCustomerTransactionsPanel = createAction('[All Customers: Summary]: Open Transactions Panel');
export const GetCustomerTransactionsTableLoading = createAction(
  '[All Customers: Summary]: Get Transactions Table Loading',
);
export const GetCustomerTransactionsTableSuccess = createAction(
  '[All Customers: Summary]: Get Transactions Table Success',
  props<{ res: any }>(),
);
export const GetCustomerTransactionsTableFailed = createAction(
  '[All Customers: Summary]: Get Transactions Table Failed',
  props<{ error: any }>(),
);
export const GetCustomerTransactionsCountSuccess = createAction(
  '[All Customers: Summary]: Get Transactions Count Success',
  props<{ res: number }>(),
);
export const GetCustomerTransactionsCountFailed = createAction(
  '[All Customers: Summary]: Get Transactions Count Failed',
  props<{ error: any }>(),
);

// Customer Tags panel
export const OpenCustomerTagsPanelAC = createAction('[All Customers: Summary]: Open Customer Tags Panel');
export const GetCustomerTagsTableACLoading = createAction('[All Customers: Summary]: Get Customer Tags Table Loading');
export const GetCustomerTagsTableACSuccess = createAction(
  '[All Customers: Summary]: Get Customer Tags Table Success',
  props<{ res: any[] }>(),
);
export const GetCustomerTagsTableACFailed = createAction(
  '[All Customers: Summary]: Get Customer Tags Table Failed',
  props<{ error: any }>(),
);
export const GetCustomerTagsCountACSuccess = createAction(
  '[All Customers: Summary]: Get Customer Tags Count Success',
  props<{ res: number }>(),
);
export const GetCustomerTagsCountACFailed = createAction(
  '[All Customers: Summary]: Get Customer Tags Count Failed',
  props<{ error: any }>(),
);

// Coupons panel
export const OpenCustomerCouponsPanel = createAction('[All Customers: Summary]: Open Coupons Panel');
export const GetCustomerCouponsTableLoading = createAction('[All Customers: Summary]: Get Coupons Table Loading');
export const GetCustomerCouponsTableSuccess = createAction(
  '[All Customers: Summary]: Get Coupons Table Success',
  props<{ res: any[] }>(),
);
export const GetCustomerCouponsTableFailed = createAction(
  '[All Customers: Summary]: Get Coupons Table Failed',
  props<{ error: any }>(),
);
export const GetCustomerCouponsCountSuccess = createAction(
  '[All Customers: Summary]: Get Coupons Count Success',
  props<{ res: number }>(),
);
export const GetCustomerCouponsCountFailed = createAction(
  '[All Customers: Summary]: Get Coupons Count Failed',
  props<{ error: any }>(),
);

// Action buttons
export const DeactivateCustomer = createAction('[All Customers: Summary]: Deactivate Customer');
export const DeactivateCustomerSuccess = createAction(
  '[All Customers: Summary]: Deactivate Customer Success',
  props<{ res: any }>(),
);
export const DeactivateCustomerFailed = createAction(
  '[All Customers: Summary]: Deactivate Customer Failed',
  props<{ error: any }>(),
);

export const AnonymizeCustomer = createAction('[All Customers: Summary]: Anonymize Customer');
export const AnonymizeCustomerSuccess = createAction(
  '[All Customers: Summary]: Anonymize Customer Success',
  props<{ res: any }>(),
);
export const AnonymizeCustomerFailed = createAction(
  '[All Customers: Summary]: Anonymize Customer Failed',
  props<{ error: any }>(),
);

// Modal openers
export const OpenCustomerConsentModal = createAction('[All Customers: Summary]: Open Consent Modal');
export const OpenCustomerCreateTicketModal = createAction('[All Customers: Summary]: Open Create Ticket Modal');
export const CloseCustomerCreateTicketModal = createAction('[All Customers: Summary]: Close Create Ticket Modal');
export const OpenCustomerAddToListModal = createAction('[All Customers: Summary]: Open Add To List Modal');

// Create Ticket
export const CreateTicketCustomer = createAction('[All Customers: Summary]: Create Ticket');
export const CreateTicketCustomerSuccess = createAction(
  '[All Customers: Summary]: Create Ticket Success',
  props<{ res: any }>(),
);
export const CreateTicketCustomerFailed = createAction(
  '[All Customers: Summary]: Create Ticket Failed',
  props<{ error: any }>(),
);

// Add to List
export const AddCustomerToList = createAction('[All Customers: Summary]: Add To List');
export const AddCustomerToListSuccess = createAction(
  '[All Customers: Summary]: Add To List Success',
  props<{ res: any }>(),
);
export const AddCustomerToListFailed = createAction(
  '[All Customers: Summary]: Add To List Failed',
  props<{ error: any }>(),
);

// Panel pagination/filter actions
export const ACPanelItemsChanged = createAction(
  '[All Customers: Summary]: Panel Items Changed',
  props<{ panel: string; pageSize: number }>(),
);
export const ACPanelSortChanged = createAction(
  '[All Customers: Summary]: Panel Sort Changed',
  props<{ panel: string; sortField: string }>(),
);
export const ACPanelOrderChanged = createAction(
  '[All Customers: Summary]: Panel Order Changed',
  props<{ panel: string; sortOrder: string }>(),
);
export const ACPanelPageChanged = createAction(
  '[All Customers: Summary]: Panel Page Changed',
  props<{ panel: string; pageIndex: number }>(),
);
export const ACTagsStatusChanged = createAction(
  '[All Customers: Summary]: Tags Status Changed',
  props<{ active: boolean }>(),
);

// Reload panel data (after pagination/filter change)
export const ReloadCustomerCampaigns = createAction('[All Customers: Summary]: Reload Campaigns');
export const ReloadCustomerTickets = createAction('[All Customers: Summary]: Reload Tickets');
export const ReloadCustomerTransactions = createAction('[All Customers: Summary]: Reload Transactions');
export const ReloadCustomerTags = createAction('[All Customers: Summary]: Reload Tags');
export const ReloadCustomerCoupons = createAction('[All Customers: Summary]: Reload Coupons');

export const ACCouponsFilterChanged = createAction(
  '[All Customers: Summary]: Coupons Filter Changed',
  props<{ used: boolean | null; given: boolean | null; couponSetId: number | null }>(),
);
